import { cn } from '@/lib/utils';
import { Check } from '@mynaui/icons-react';
import { FunctionComponent, useId, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import PortalTooltip from './PortalTooltip';

interface iCoordsProps {
  value: string;
}
export const ID: FunctionComponent<iCoordsProps> = ({ value }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { t } = useTranslation('components');
  const id = useId();
  const copiedTimeout = useRef<any | null>(null);

  const _handleCopyCoordinates = () => {
    navigator.clipboard.writeText(value);
    toast.success(t('id.copiedToClipboard'));
    setIsCopied(true);
    if (copiedTimeout.current) clearTimeout(copiedTimeout.current);
    copiedTimeout.current = setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <>
      <pre
        data-tooltip-id={id}
        data-tooltip-delay-show={320}
        onClick={_handleCopyCoordinates}
        className='text-sm whitespace-pre-wrap cursor-copy font-mono font-medium relative bg-slate-100 dark:bg-stone-900/70 rounded-sm px-1.5 py-0.75 w-fit'>
        {value}
        <span
          className={cn(
            'absolute inset-0 rounded-sm bg-slate-100 dark:bg-stone-900/70 backdrop-blur-sm flex items-center justify-center text-xs font-medium pointer-events-none transition-all',
            isCopied ? 'opacity-100' : 'opacity-0',
          )}>
          <span
            className={cn(
              'transition-all font-sans font-medium flex items-center gap-1',
              isCopied ? 'scale-100' : 'scale-70',
            )}>
            <Check className='size-4 stroke-2' />
            {t('id.copied')}
          </span>
        </span>
      </pre>
      <PortalTooltip id={id}>
        <span className='text-sm font-medium'>
          {t('id.label')} <span className='text-xs font-medium opacity-70'>{t('id.clickToCopy')}</span>
        </span>
        <div className='font-mono leading-tight mt-0.5'>
          <pre>{value}</pre>
        </div>
      </PortalTooltip>
    </>
  );
};
